import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Fazenda } from '../interface/fazenda';

@Injectable({
  providedIn: 'root'
})
export class FazendaLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrfazenda`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<Fazenda> {
    return this.httpClient.get<Fazenda>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CZABCODIGO', optional: true, gridColumns: 3, label: 'Cód Fazenda'},
      {property: 'CZABDESC'  , optional: true, gridColumns: 6, label: 'Descr. Fazenda'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CZABCODIGO', label: 'Cód. Fazenda'},
      {property: 'CZABDESC'  , label: 'Fazenda'},
      {property: 'CZABNMMUNI', label: 'Município'},
      {property: 'CZABESTADO', label: 'Estado'},
    ];
  }

  getFieldFormater(value: Fazenda): string {
    return `${value.CZABCODIGO} - ${value.CZABDESC}`;
  }
}
